import { useEffect, useState, useCallback } from 'react';
import { useLocation, useParams } from 'react-router-dom';

import styles from '../../css/admin/Status.module.css';
import { useLanguage } from '../../hooks/LanguageContext'; // Import useLanguage hook
import useAxiosAdminFetch from '../../hooks/useAxiosAdminFetch';
import Item from '../admin/Item';
import Navbar from '../admin/NavBar';
import removeUnit from '../admin/removeUnit';
import StatusMessage from '../admin/StatusMessage';
import translations from '../admin/translations'; // 번역 객체 가져오기
import { formatGiftSerialDisplay } from '../../utils/formatGiftSerial';

function formatValidityDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${year}년 ${month}월 ${day}일까지`;
}

export default function VerifyFailure() {
  const location = useLocation();
  const state = location.state;
  const failMessage = typeof state === 'string' ? state : state?.failDesc;
  const verifyData = typeof state === 'object' ? state : null;
  const [giftData, setGiftData] = useState();
  // 구매/발급 시점 giftId+version+serial 조회용(SMS 링크로 state 없이 진입하는 경우 대비).
  const [serialData, setSerialData] = useState();
  const { storeNo, memberGiftNo, giftNo } = useParams();
  const { fetchData } = useAxiosAdminFetch(); // 로딩의미: api 호출 중
  const { language } = useLanguage(); // 언어 상태 가져오기
  const t = translations[language]; // Translations short-hand

  const GiftRendering = useCallback(async () => {
    if (!giftNo) return;
    try {
      const url = `${process.env.REACT_APP_API_SERVER}gift/${giftNo}`;
      const response = await fetchData({
        method: 'GET',
        url: url,
      });
      setGiftData(response.data.data);
    } catch (error) {
      //navigate(`/admin/status/${storeNo}`);
    }
  }, [giftNo, fetchData]);

  const SerialRendering = useCallback(async () => {
    if (!memberGiftNo) return;
    try {
      const url = `${process.env.REACT_APP_API_SERVER}user-gift/${memberGiftNo}`;
      const response = await fetchData({ method: 'GET', url: url });
      setSerialData(response.data.data);
    } catch (error) {
      // 조회 실패해도 verifyData/giftData 폴백으로 표시되므로 무시.
    }
  }, [memberGiftNo, fetchData]);

  useEffect(() => {
    GiftRendering();
    SerialRendering();
  }, []);

  return (
    <>
      <Navbar />
      <div className={styles.container}>
        <Item
          image={giftData ? giftData.thumbnailFileUrl : ''}
          title={giftData ? giftData.giftName : ''}
          content={giftData ? giftData.giftDesc : ''}
          cost={giftData ? giftData.price.toLocaleString() + t.money : ''}
        >
          <div>
            {verifyData?.validDttm ?? serialData?.validDttm ? (
              <div>
                {t.validityPeriodDate}{' '}
                {formatValidityDate(
                  verifyData?.validDttm ?? serialData?.validDttm
                )}
              </div>
            ) : (
              <div> {t.validityPeriod(removeUnit(giftData?.validity))}</div>
            )}
          </div>
          <div>
            {t.giftSerialNumber}{' '}
            {formatGiftSerialDisplay(serialData ?? verifyData ?? giftData)}
          </div>
          <div>
            {t.salesState}{' '}
            {giftData
              ? t.stateDesc[giftData.stateDesc] || giftData.stateDesc
              : ''}
          </div>
        </Item>
        <StatusMessage
          situation="verification"
          status="failure"
          desc={failMessage}
          giftName={giftData ? giftData.giftName : ''}
        />
      </div>
    </>
  );
}
